import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useMutation } from '@tanstack/react-query'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { usersService } from '../../../app/services/usersService'
import { toast } from '../../components/ui/use-toast'

const schema = z
  .object({
    password: z.string(),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'A confirmação da senha tem que ser igual a senha',
    path: ['confirmPassword'],
  })

type FormData = z.infer<typeof schema>

export const usePasswordChangeController = () => {
  const { id } = useParams()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(schema),
  })

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ password, id }: { password: string; id: string }) => {
      return usersService.userPasswordUpdate(password, id)
    },
  })

  const handleResetPassword = handleSubmit(async (data) => {
    try {
      if (id) {
        const response = await mutateAsync({ password: data.password, id })

        if (response.success) {
          toast({
            title: 'Senha atualizada com sucesso!',
          })
        }
      }
    } catch (error) {
      console.log(error)
    }
  })

  return {
    register,
    errors,
    isPending,
    handleResetPassword,
  }
}
